<template>
  <div>
    <CmsTemplate :pageName="'parks'" :pageTitle="$t('content.tecnoparks')">
      <div class="row">
        <div class="col-xs-12 col-sm-4 col-md-3 pull-right">
          <label>{{ $t('content.byFocus') }}</label>
          <select v-model="focus" class="form-control" v-on:change="applyFilters">
            <option value="">{{ $t('content.selectFocus') }}</option>
            <option>Aeronáutico</option>
            <option>Agronegócio</option>
            <option>Alimentos</option>
            <option>Economia criativa</option>
            <option>Eletrônica</option>
            <option>Energia</option>
            <option>Espacial</option>
            <option>Meio ambiente</option>
            <option>Mineral</option>
            <option>Petróleo e gás natural</option>
            <option>Química</option>
            <option>Recursos hídricos</option>
            <option>Saúde animal</option>
            <option>Saúde humana</option>
            <option>Tecnologia da informação</option>
            <option>Telecomunicações</option>
            <option>Transporte aquaviario e construção naval</option>
            <option>Transporte terrestre e hidroviário</option>
          </select>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3 pull-right">
          <label>{{ $t('content.byState') }}</label>
          <select v-model="state" class="form-control" v-on:change="applyFilters">
            <option value="">{{ $t('content.selectState') }}</option>
            <option>AC</option>
            <option>AL</option>
            <option>AP</option>
            <option>AM</option>
            <option>BA</option>
            <option>CE</option>
            <option>DF</option>
            <option>ES</option>
            <option>GO</option>
            <option>MA</option>
            <option>MT</option>
            <option>MS</option>
            <option>MG</option>
            <option>PA</option>
            <option>PB</option>
            <option>PR</option>
            <option>PE</option>
            <option>PI</option>
            <option>RJ</option>
            <option>RN</option>
            <option>RS</option>
            <option>RO</option>
            <option>RR</option>
            <option>SC</option>
            <option>SP</option>
            <option>SE</option>
            <option>TO</option>
          </select>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3 pull-right">
          <label>{{ $t('commons.stage') }}</label>
          <select v-model="stage" class="form-control" v-on:change="applyFilters">
            <option value="">{{ $t('content.selectStage') }}</option>
            <option value="Planejamento">{{ $t('commons.planning') }}</option>
            <option value="Implantação">{{ $t('commons.implantation') }}</option>
            <option value="Operação">{{ $t('commons.operation') }}</option>
          </select>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-3 pull-right">
          <label for="search-text">{{ $t('content.search') }}</label>
          <input id="search-text" type="search" class="form-control" v-model="search">
        </div>
      </div>
      <br>
      <div v-if="parks.length < 1" class="alert alert-info">
        <h4><i class="icon fa fa-info"></i> {{ $t('content.notFound') }} </h4>
        {{ $t('content.noParksFound') }}
      </div>
      <br>
      <transition-group name="fade">
        <div v-for="park in filteredParks" class="col-xs-12 col-sm-4 col-lg-3" v-bind:key="park.id">
          <a tabindex="0"
            role="button"
            data-toggle="popover"
            data-trigger="focus"
            data-placement="top"
            data-html="true"
            :data-content="getParkDataForTooltip(park)">
            <div class="box box-solid">
              <div class="box-header with-border m-box__header">
                <h3 class="box-title">{{ park.name }}</h3>
              </div>
              <div class="box-body">
                <div class="m-box__logo-picture"
                     v-bind:style="{ 'background-image': 'url(' + park.logoPicture + ')' }"
                ></div>
              </div>
            </div>
          </a>
        </div>
      </transition-group>
    <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
      <span slot="no-more"></span>
    </infinite-loading>
  </CmsTemplate>
</div>
</template>
<script>
import CmsTemplate from '@/pages/portal/CmsTemplate'
import { BackendApi } from '@/services/backend_api'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'ParksPage',
  components: { CmsTemplate, InfiniteLoading },
  data () {
    return {
      parks: [],
      search: '',
      state: '',
      stage: '',
      focus: '',
      nextUri: '/parks/that-answered-general-information-quiz'
    }
  },
  methods: {
    applyFilters () {
      this.parks = []
      this.nextUri = '/parks/that-answered-general-information-quiz'
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
      })
    },
    getParkDataForTooltip (park) {
      let website = park.website
      if (!/^(f|ht)tps?:\/\//i.test(website)) {
        website = 'http://' + website
      }

      return '<p><strong>' + this.$i18n.t('commons.name') + ':</strong> ' + park.name + '</p>' +
      '<p><strong>' + this.$i18n.t('commons.initials') + ':</strong> ' + park.initials + '</p>' +
      '<p><strong>' + this.$i18n.t('commons.email') + ':</strong> ' + park.email + '</p>' +
      '<p><strong>' + this.$i18n.t('commons.city') + ':</strong> ' + park.city + '</p>' +
      '<p><strong>' + this.$i18n.t('commons.state') + ':</strong> ' + park.state + '</p>' +
      '<p><strong>' + this.$i18n.t('commons.phoneNumber') + ':</strong> ' + park.phoneNumber + '</p>' +
      '<p><strong>' + this.$i18n.t('commons.website') + ':</strong><a href="' + website + '" target="_blank"> ' + website + '</a></p>' +
      '<p><strong>' + this.$i18n.t('commons.legalResponsible') + ':</strong> ' + park.legalResponsible + '</p>'
    },
    infiniteHandler ($state) {
      let uri = this.createUri()
      this.getParks(uri)
        .then((r) => {
          let payload = r.data
          this.updateNextUri(payload)
          this.updateParksObject(payload)
          this.updatePopovers()

          $state.loaded()
          if (!this.nextUri) {
            $state.complete()
          }
        })
    },
    createUri () {
      let uri = this.nextUri
      if (uri.indexOf('?') < 0) {
        uri += '?'
      }
      if (this.stage) {
        uri += '&stage=' + this.stage
      }
      if (this.state) {
        uri += '&state=' + this.state
      }
      if (this.focus) {
        uri += '&focus=' + this.focus
      }
      return uri
    },
    getParks (uri) {
      return BackendApi.get(BackendApi.getAnonymousClient(), uri)
    },
    updateNextUri (payload) {
      let nextUri = null
      for (let obj in payload) {
        if (this.isPaginationObject(payload[obj]) && this.hasNextUri(payload[obj]._links)) {
          nextUri = payload[obj]._links.next.href
        }
      }
      this.nextUri = nextUri
    },
    updateParksObject (payload) {
      for (let obj in payload) {
        if (!this.isPaginationObject(payload[obj]) && obj !== 'total') {
          this.parks.push(payload[obj])
        }
      }
    },
    updatePopovers () {
      setTimeout(() => {
        $('[data-toggle="popover"]').popover()
      }, 100)
    },
    isPaginationObject (payload) {
      return payload._links && payload._links.first
    },
    hasNextUri (links) {
      return links.next
    }
  },
  computed: {
    filteredParks () {
      return this.parks.filter((p) => {
        return p.name.toLowerCase().includes(this.search.toLowerCase()) ||
          p.initials.toLowerCase().includes(this.search.toLowerCase()) ||
          p.email.toLowerCase().includes(this.search.toLowerCase()) ||
          p.city.toLowerCase().includes(this.search.toLowerCase()) ||
          p.state.toLowerCase().includes(this.search.toLowerCase()) ||
          p.phoneNumber.toLowerCase().includes(this.search.toLowerCase()) ||
          p.website.toLowerCase().includes(this.search.toLowerCase()) ||
          p.legalResponsible.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  watch: {
    search () {
      this.updatePopovers()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ParksPage.vue?45048104